import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=81a4d2bc&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=81a4d2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a4d2bc",
  null
  
)

export default component.exports